"use strict";

var LoggerInstance = require("js-logger").get("MySponsorshipsHelper");

var AbstractPledgeManagementHelper = require("./AbstractPledgeManagementHelper");
var AccountStore = require("./AccountStore");

var Spinner = require("../client/Spinner");

var AccountApi = require("../api/AccountApi");

var SubmitButtonHelper = require("../commonComponents/SubmitButtonHelper");

var WizardConstants = require("../constants/WizardConstants");

var BootstrapPrompt = require("../shared/BootstrapPrompt");
var HtmlHelper = require("../shared/HtmlHelper");
var SponsorshipHelper = require("../sponsorshipComponents/SponsorshipHelper");

var MySponsorshipsHelper = class extends AbstractPledgeManagementHelper {
	constructor() {
		var singleSponsorshipEditComponentName = "mySponsorships.populated.singleSponsorship.edit";
		var donateToAllCheckboxComponentName = "mySponsorshipsDonateToAll";
		var donateToSingleCheckboxComponentName = "mySponsorshipsDonateToSingle";

		super({
			cancelPledgeEditLinkMessageMapper: "cancelMySponsorshipEdit",
			cancelWholePledgeLinkMessageMapper: "cancelMySponsorship",
			componentSelector: "[data-component='mySponsorships']",
			displayMessagesWizard: "wizardMySponsorshipsDisplayMessages",
			donateToAllCheckboxComponentName,
			donateToAllCheckboxSelector: `input[data-component="${donateToAllCheckboxComponentName}"]`,
			donateToSingleCheckboxComponentName,
			donateToSingleCheckboxSelector: `input[data-component="${donateToSingleCheckboxComponentName}"]`,
			editMyPledgeLinkMessageMapper: "editMySponsorship",
			makeDonationSelector: "[data-component='mySponsorshipsMakeDonation']",
			myRecurringPopulatedSingleRecurringSelector: "[data-component='myRecurring.populated.singleRecurring']",
			myRecurringSelector: "[data-component='myRecurring']",
			singlePledgeEditComponentName: singleSponsorshipEditComponentName,
			singlePledgeSelector: "[data-component='mySponsorships.populated.singleSponsorship']",
			singlePledgeEditSelector: `[data-component='${singleSponsorshipEditComponentName}']`,
			singlePledgeEditAmountSelector: "[data-component='mySponsorships.populated.singleSponsorship.edit.amount']"
		});

		this.singleSponsorshipEditComponentName = singleSponsorshipEditComponentName;

		// private methods
		this._getMySponsorshipHtml = (event, isEditing, newSponsorshipId) => {
			return super.getComponentHtml(event, newSponsorshipId, ($currentSponsorship, sponsorshipId, componentId, deferred) => {
				AccountApi.myPledgeGet(sponsorshipId, componentId, isEditing, /*sponsorshipType*/ "CHILD").done((data) => {
					var $data = $(data);

					var $newEditForm = $data.find("form#editMySponsorship");
					var newId = $newEditForm.attr("id") + "-" + $data.closest("[data-component='mySponsorships.populated.singleSponsorship']").attr("data-pledge-id");
					HtmlHelper.setUniqueFormId($newEditForm, newId);

					$currentSponsorship.replaceWith($data);
					if (isEditing) {
						this.initializeEdit($data);
						HtmlHelper.focusAndSelectFirstField($data);
					} else {
						this.initializeComponent($data);
					}

					deferred.resolve($data);
				}).fail((jqXHR, textStatus) => {
					this._resolveError(jqXHR, textStatus, deferred);
				});
			});
		};
	}

	cancelMySponsorshipEdit(event) {
		return super.cancelPledgeEdit(event, ($currentSponsorship) => {
			this._getMySponsorshipHtml(event, /*isEditing*/false)
				.always(() => Spinner.removeSpinner($currentSponsorship));
		});
	}

	cancelWholeSponsorship(event) {
		return super.cancelWholePledge(event, ($currentSponsorship, sponsorshipId) => {
			//Call API to delete
			AccountApi.myPledgesCancel(sponsorshipId, /*sponsorshipType*/ "CHILD").done((data) => {
				var $sponsorships = $currentSponsorship.closest("[data-component='mySponsorships']");

				if ((data || {}).refresh || $sponsorships.find("[data-component='mySponsorships.populated.singleSponsorship']").length <= 1) {
					//If we canceled the last sponsorship or canceled a sponsorship with a recurring, we want to reload the entire page
					window.location.reload();
				} else {
					HtmlHelper.deleteChildOfColumnAndPromoteColumnChildren($currentSponsorship);
					Spinner.removeSpinner();
				}
			}).fail((jqXHR, textStatus) => {
				this._resolveError(jqXHR, textStatus);
				Spinner.removeSpinner();
			});
		});
	}

	editMySponsorship(event) {
		return super.editPledge(event, ($currentSponsorship) => {
			this._getMySponsorshipHtml(event, /*isEditing*/true)
				.always(() => Spinner.removeSpinner($currentSponsorship));
		});
	}

	makeDonation(event, isDesignMode) {
		return super.makeDonation(event, isDesignMode, (sponsorshipIds) => {
			AccountApi.myPledgesMakeDonation({ pledgeIds: sponsorshipIds }, /*sponsorshipType*/ "CHILD").done((response) => {
				window.location = "/shoppingcart";
			}).fail(() => {
				BootstrapPrompt.alert(AccountStore.getWizardValue(
					WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES,
					WizardConstants.SHOPPING_CART_MESSAGE_FIELDS.ADD_TO_CART_ERROR,
					{ tangibleType: "donation(s)" }
				));
				Spinner.removeSpinner();
			});
		});
	}

	initializeMySponsorships($component, isDesignMode) {
		super.initializeComponent($component, isDesignMode);
	}

	initializeMySponsorshipsEdit($component) {
		super.initializeEdit($component);
	}

	initializeMySponsorshipsButtons($component, isDesignMode) {
		super.initializePledgeButtons($component, isDesignMode);
	}

	saveMySponsorship(event) {
		return super.save(event, ($currentSponsorship, sponsorshipId, componentId, editSponsorshipData) => {
			if (!editSponsorshipData.amount && editSponsorshipData.frequency) {
				var $editSponsorship = $currentSponsorship.find(`[data-component='${this.singleSponsorshipEditComponentName}']`);
				editSponsorshipData.amount = SponsorshipHelper.calculateUpdatedTotalForMySponsorships($editSponsorship, editSponsorshipData.frequency);
			}

			//Call API to edit
			AccountApi.myPledgesEdit(sponsorshipId, componentId, editSponsorshipData, /*sponsorshipType*/ "CHILD").done((data) => {
				var actionData = SubmitButtonHelper.getPostSubmitActionData(`[data-component='${this.singleSponsorshipEditComponentName}']`);
				var $data = $(data);

				$currentSponsorship.replaceWith($data);
				this.initializeMySponsorships($data);
				HtmlHelper.focusAndSelectFirstField($data);

				this._refreshAssociatedRecurringHtml(sponsorshipId).done(() => Spinner.removeSpinner());

				SubmitButtonHelper.performPostSubmitAction(
					`[data-component='${this.singleSponsorshipEditComponentName}']`,
					{ actionData }
				);
			}).fail((jqXHR, textStatus) => {
				this._resolveError(jqXHR, textStatus);
				Spinner.removeSpinner();
			});
		});
	}
};

module.exports = new MySponsorshipsHelper();